const sznIVASetEmailHash = (hash) => {
	if (window.sznIVA && window.sznIVA.IS) {
		window.sznIVA.IS.updateIdentities({eid: hash})
	} else {
		window.addEventListener('szn:identities:ready', function() {
			window.sznIVA.IS.updateIdentities({eid: hash})
		})
	}
}

document.addEventListener('DOMContentLoaded', () => {
    // Nastavení maximální životnosti cache v milisekundách (12 hodin)
    const CACHE_LIFETIME = 12 * 60 * 60 * 1000;

    // Zkontrolujte URL parametry pro odhlášení nebo přihlášení
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('logged_out') || urlParams.has('logged_in')) {
        // Uživatel se odhlásil nebo přihlásil - vymažeme cache
        localStorage.removeItem('cachedUserName');
        localStorage.removeItem('cachedUserNameTimestamp');
		localStorage.removeItem('cachedEmailHash');
    }

    setTimeout(() => {
        const userNameElements = document.querySelectorAll('.js-user-name');

        if (userNameElements.length > 0) {
            // Zkontrolujte, zda je uživatelské jméno v localStorage a jestli není cache zastaralá
            const cachedUserName = localStorage.getItem('cachedUserName');
            const cachedUserNameTimestamp = localStorage.getItem('cachedUserNameTimestamp');
			const cachedEmailHash = localStorage.getItem('cachedEmailHash');
            const now = new Date().getTime();

            if (cachedUserName && cachedUserNameTimestamp && (now - cachedUserNameTimestamp) < CACHE_LIFETIME) {
                // Použijeme cache
                userNameElements.forEach((element) => {
                    element.innerText = cachedUserName;
                });
				sznIVASetEmailHash(cachedEmailHash);
            } else {
                // AJAX volání pomocí Fetch API
                fetch(window.ajaxURL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    body: new URLSearchParams({
                        action: 'get_user_name'
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            const userName = data.data.name || 'Uživatel';
                            userNameElements.forEach((element) => {
                                element.innerText = userName;
                            });
                            // Uložení uživatelského jména a aktuálního času do localStorage
                            localStorage.setItem('cachedUserName', userName);
                            localStorage.setItem('cachedUserNameTimestamp', now.toString());
							localStorage.setItem('cachedEmailHash', data.data.email_hash);

							sznIVASetEmailHash(data.data.email_hash);
                        } else {
                            console.error(data.data);
                        }
                    })
                    .catch(error => {
                        console.error('There was a problem with the AJAX request:', error);
                    });
            }
        }
    }, 0);
});
